<template>
  <div class="containerStepViewer">
    <v-row class="buttonBackConteiner no-print">
      <QuotationBackButton
        class="buttonBack"
        v-if="currentQuotation.cancelada_em == null"
        @back="previousStep"
      />
      <v-spacer />
    </v-row>
    <v-row>
      <v-spacer />
      <QuotationFloatActionButton
        class="messageInfoCostsViewer"
        v-if="!getIsEmployeeUser"
        :message="infoMessage"
      />
    </v-row>
    <v-row>
      <v-col cols="12">
        <QuotationCostsViewerForm
          :form="form"
          :formProduct="formProduct"
          :formCost="formCost"
          :formInsured="formInsured"
          :formRisk="formRisk"
          :readonly-form="form"
          @submit="submit"
          @cancel="cancelQuotationButton"
          v-if="!getUserIsGuest"
          v-model="formCosts"
          value="formCosts"
          :options-quotation="optionsQuotation"
          :modality="modality"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import QuotationCostsViewerForm from "../components_agro/QuotationCostsViewerForm";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { mapState } from "vuex";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";

export default {
  name: "QuotationStepCostsViewer",
  data: () => ({
    formCosts: {}
  }),
  components: {
    QuotationCostsViewerForm,
    QuotationBackButton,
    QuotationFloatActionButton
  },
  mixins: [QuotationMixin],
  computed: {
    ...mapState("me", ["userIsEmployee", "userIsGuest"]),
    ...mapState("quotation", ["currentQuotation"]),
    nextQuotationStep() {
      return {
        name: "quotation step insured2",
        step: 6
      };
    },
    previousQuotationStep() {
      let step = "";
      if (this.userIsEmployee) {
        step = {
          name: "quotation step costs",
          step: 4
        };
      } else {
        step = {
          name: "quotation step insured",
          step: 3
        };
      }
      return step;
    },
    getUserIsGuest() {
      return this.userIsGuest;
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    productIsCafezal() {
      return this.formProduct === "cafezal";
    },
    productIsAgricola() {
      return this.formProduct === "agricola";
    },
    infoMessage() {
      return "Compare e clique em uma das cotações abaixo para seguir. Em seguida, defina a forma de pagamento. Após este passo, será apresentado o documento de aceite, leia-o até o final e clique em Aceitar para prosseguir.";
    }
  },
  created() {
    this.formCosts = { ...this.form };
  },
  methods: {
    getFormForNavigation() {
      return this.formCosts;
    },
    submit(form) {
      if (this.form.selectedCost == null) {
        return;
      }
      this.$emit(
        "updateStep",
        this.payloadQuotation(form, this.nextQuotationStep)
      );
    },
    cancelQuotationButton() {
      this.$emit("cancel");
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formCosts, this.previousQuotationStep)
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    formInsured: {
      type: Object
    },
    formCost: {
      type: Object
    },
    formProduct: {
      type: Object
    },
    formRisk: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    modality: {
      type: String
    }
  }
};
</script>
<style lang="sass">
.containerStepViewer
  margin: 0 auto !important
  width: 100% !important
.messageInfoCostsViewer
  margin-top: -57px
  margin-right: 90px
@media print
  .no-print
    display: none
</style>
